var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('AlertsTemplate',{attrs:{"page_content":_vm.page_content,"isPowerdata":_vm.isPowerdata}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }